import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dashboardAPI } from "../../services/api";
import { DashboardState } from "../../types";

export const getDashboardSummary = createAsyncThunk(
  "dashboard/getDashboardSummary",
  async (params: { days?: number } = {}, { rejectWithValue }) => {
    try {
      const response = await dashboardAPI.getSummary(params);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch dashboard summary",
      );
    }
  },
);

const initialState: DashboardState = {
  kpis: {
    totalShipments: 0,
    inTransit: 0,
    completed: 0,
    activeUsers: null,
    myOpenShipments: null,
  },
  trends: {
    totalShipments: { value: 0, percent: 0 },
    inTransit: { value: 0, percent: 0 },
    completed: { value: 0, percent: 0 },
  },
  statusCounts: {
    Order: 0,
    AwaitingPickup: 0,
    InTransit: 0,
    Completed: 0,
    ReadyForPickup: 0,
  },
  recentShipments: [],
  recentMembers: [],
  dailyTimeseries: [],
  period: { days: 30, start: null, end: null },
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.kpis = action.payload.kpis;
        state.trends = action.payload.trends;
        state.statusCounts = action.payload.statusCounts;
        state.recentShipments = action.payload.recentShipments;
        state.recentMembers = action.payload.recentMembers;
        state.dailyTimeseries = action.payload.dailyTimeseries ?? [];
        state.period = action.payload.period;
        state.error = null;
      })
      .addCase(getDashboardSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = dashboardSlice.actions;

export default dashboardSlice.reducer;
